import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'price'
})
export class PricePipe implements PipeTransform {
    transform(value: number, currency: string = '€', decimalPlaces: number = 2): string {
        if (value == null) return '-';

        // Formatta il numero con separatori decimali e simbolo di valuta
        return `${value.toFixed(decimalPlaces).replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${currency}`;
    }
}
